import {useEffect, useState} from "react";
import {Box, Container, Grid, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import theme from "../../../theme";
import parsePrices from "functions/parseSWPrices";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ProductItem from "../../../products/item-horizontal";
import ProductThumbnail from "../../../products/thumbnail";
import {Alert} from "@material-ui/lab";
import SlickWrapper from "../../../slick/productSlider";
import {useTranslation} from "tools/i18n";
import Image from 'next/image';
import { getCategoryBreadcrumb } from '@functions/productOps';
import {
	getFastDelivery, getMarketingLabel,
	getProductVariants,
	getStock,
	getUUID,
	preventFloatRoundingIssues
} from '@functions/elevateOps';
import urlNormalizer from '@tools/urlNormalization';
import { useRouter } from 'next/router';
import { elevateClickNotification } from '@tools/elevateClient';

const useStyles = makeStyles(theme => ({
	wrapper: {
		marginTop: 40,
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		}
	},
	title: {
		marginBottom: 10,
		fontSize: 13,
		fontWeight: 300,
		letterSpacing: 0.5,
		textTransform: 'uppercase'
	},
}), {name: 'ProductCrossSell'});

export default function CrossSell({productId}) {
	const classes = useStyles();
	const router = useRouter();
	const [slots, setSlots] = useState([]);
	const {t} = useTranslation(['product-info']);

	useEffect(async () => {
		let crossSellData = await fetch('/api/product/get/cross-sell/' + productId, {
			method: "get",
			credentials: 'include'
		});
		let crossSellResults = await crossSellData.json();
		setSlots(crossSellResults.slots);
	}, [productId]);

	function getProductUrl(product) {
		if (product.seoUrls) {
			return '/' + product.seoUrls[0].seoPathInfo;
		} else {
			return '/detail/' + product.id;
		}
	}

	function getProductPrices(product) {
		return parsePrices(product.calculatedPrices && product.calculatedPrices.length > 0 ? product.calculatedPrices[0] : product.calculatedPrice);
	}

	function urlNormalize(url) {
		return urlNormalizer(url, router.basePath);
	}

	function getProductImage(product) {
		let productImages = product.media?.images;

		if(!productImages || productImages.length <= 0) {
			return { src: '/images/placeholder/product.jpg', width: 550, height: 510 };
		}

		let imageSource = productImages[0].sources[0];

		if(productImages.length > 1) {
			productImages.forEach((image) => {
				if (image['sources'][0].width === 550) {
					imageSource = image['sources'][0];
				}
			});
		}

		return {
			src: imageSource.url,
			width: imageSource.width || 550,
			height: imageSource.height || 510
		}
	}

	async function onClick(product) {
	}

	function renderSlot(slot) {
		return <div className={classes.wrapper} key={slot.id + '-key'}>
			<Container disableGutters>
				{slot.products.length > 0 &&
					<Typography className={classes.title}>{t('style-with-title')}</Typography>
				}

				{slot.products.length > 0 &&
					slot.products.map((product, key) =>
						product.available &&
							<ProductItem
								id={product.id}
								propertyIds={[...getMarketingLabel(product)]}
								productNumber={product.productNumber}
								name={product.translated.name}
								manufacturer={product.brand}
								link={urlNormalize(`/${product.seoUrls?.[0]?.seoPathInfo || 'detail/' + product.id}`)}
								prices={getProductPrices(product)}
								image={<ProductThumbnail image={product.cover} size={120} index={0}/>}
								list={{id: product.id, name: 'cross_sell', location: router.asPath }}
								categoryBreadcrumb={[]}
								variants={false}
								stock={getStock(product)}
								fastDelivery={getFastDelivery(product)}
								available={product.available}
								clickCallback={onClick.bind(this, product)}
								elevateTicket={''}
								isMobile={false}
								addToCart={true}
								lazyHydrate={false}
								sizes={{ lg: 12, md: 12, sm: 12, xl: 12, xs: 12 }}
								position={key + 1}
								key={key}
								analytics={product?.extensions?.newport?.analytics}
							/>
						)
				}
			</Container>
		</div>
	}

	return slots && slots.map((slot) => {
		return renderSlot(slot);
	});
}
